import { xglobal } from '@polkadot/x-global';
export { packageInfo } from './packageInfo.js';
export const crypto = xglobal.crypto;
export function getRandomValues(arr) {
    return crypto.getRandomValues(arr);
}
